import { render, staticRenderFns } from "./VendorDevice.vue?vue&type=template&id=60d13d70&scoped=true&"
import script from "./VendorDevice.vue?vue&type=script&lang=js&"
export * from "./VendorDevice.vue?vue&type=script&lang=js&"
import style0 from "./VendorDevice.vue?vue&type=style&index=0&id=60d13d70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d13d70",
  null
  
)

export default component.exports